<div class="reports-header" data-cy="reports-header">
  <h2 data-cy="reports-title">VENDAS</h2>
  <div class="report-date" data-cy="report-date">
    De {{ startDate | date: "dd/MM/yyyy" }} a {{ endDate | date: "dd/MM/yyyy" }}
  </div>
</div>

<div class="reports-split mobile_reports-split" [ngClass]="{ 'hide': isLoading }" data-cy="reports-split">
  <div class="table-wrapper mobile_table-wrapper" data-cy="table-wrapper">
    <table *ngIf="sales.length > 0" class="table" data-cy="sales-table">
      <thead data-cy="table-header">
        <tr>
          <th data-cy="column-platform">Formas de acesso</th>
          <th data-cy="column-quantity">Quantidade</th>
        </tr>
      </thead>
      <tbody data-cy="table-body">
        <tr *ngFor="let sale of sales" data-cy="table-row">
          <td data-cy="cell-platform">{{ sale.plataform }}</td>
          <td data-cy="cell-quantity">{{ sale.salesCount }}</td>
        </tr>
        <tr class="aggregate" data-cy="table-row-aggregate">
          <td data-cy="cell-total-label">Total</td>
          <td data-cy="cell-total-value">{{ aggregateSales(sales) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="chart-wrapper" data-cy="chart-wrapper">
    <div class="force-height" data-cy="chart-container">
      <usage-graph-chart data-cy="usage-graph-chart"></usage-graph-chart>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-spinner-container" data-cy="loading-spinner-container">
  <mat-spinner class="spinner" data-cy="loading-spinner"></mat-spinner>
</div>
